var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99817 9.32983L2.66602 5.99768L5.99817 2.66553",
    stroke: "#008236",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 5.99805H9.66353C10.1449 5.99805 10.6215 6.09285 11.0662 6.27706C11.5109 6.46126 11.915 6.73125 12.2553 7.07161C12.5957 7.41197 12.8657 7.81603 13.0499 8.26074C13.2341 8.70544 13.3289 9.18207 13.3289 9.66341C13.3289 10.1448 13.2341 10.6214 13.0499 11.0661C12.8657 11.5108 12.5957 11.9149 12.2553 12.2552C11.915 12.5956 11.5109 12.8656 11.0662 13.0498C10.6215 13.234 10.1449 13.3288 9.66353 13.3288H7.33103",
    stroke: "#008236",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.3ec3a4e01982d9273202dbc047feb80f.svg";
export { ForwardRef as ReactComponent };